import React, { useState } from "react";
import { showError } from "../../utils/Toast";
import {
  downloadOrderInvoice,
  getInvoiceDownloadErrorMessage,
  isOrderInvoiceAvailable,
} from "../../utils/orderInvoice";

function DownloadInvoiceButton({
  order,
  className = "",
  label = "Download Invoice",
  loadingLabel = "Downloading...",
  type = "button",
}) {
  const [isDownloading, setIsDownloading] = useState(false);

  if (!isOrderInvoiceAvailable(order)) {
    return null;
  }

  const handleDownload = async () => {
    if (isDownloading) {
      return;
    }

    try {
      setIsDownloading(true);
      await downloadOrderInvoice(order);
    } catch (error) {
      const message = await getInvoiceDownloadErrorMessage(error);
      showError(message);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      type={type}
      className={className}
      onClick={handleDownload}
      disabled={isDownloading}
    >
      {isDownloading ? loadingLabel : label}
    </button>
  );
}

export default DownloadInvoiceButton;
